import { render, staticRenderFns } from "./AtomLogo.vue?vue&type=template&id=2f886ef1&"
import script from "./AtomLogo.vue?vue&type=script&lang=js&"
export * from "./AtomLogo.vue?vue&type=script&lang=js&"
import style0 from "./AtomLogo.vue?vue&type=style&index=0&id=2f886ef1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports